"use client";

import createSvgIcon from "./utils/createSvgIcon.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon([/*#__PURE__*/_jsx("path", {
  d: "M5 19h14v1H5z",
  opacity: ".3"
}, "0"), /*#__PURE__*/_jsx("path", {
  d: "M18 13h-.68l-2 2h1.91L19 17H5l1.78-2h2.05l-2-2H6l-3 3v4c0 1.1.89 2 1.99 2H19c1.1 0 2-.89 2-2v-4zm1 7H5v-1h14z"
}, "1"), /*#__PURE__*/_jsx("path", {
  d: "M12.048 12.905 8.505 9.362l4.95-4.95 3.543 3.543z",
  opacity: ".3"
}, "2"), /*#__PURE__*/_jsx("path", {
  d: "M19.11 7.25 14.16 2.3c-.38-.4-1.01-.4-1.4-.01L6.39 8.66c-.39.39-.39 1.02 0 1.41l4.95 4.95c.39.39 1.02.39 1.41 0l6.36-6.36c.39-.39.39-1.02 0-1.41m-7.06 5.65L8.51 9.36l4.95-4.95L17 7.95z"
}, "3")], 'HowToVoteTwoTone');